import { UrlParams } from '@provision/portal-routes';
import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { MAP_URL_ENTITY_NAME_TO_ENTITY } from 'src/pages/CustomViews/constants';
import {
  getFirstAccessibleTabPath,
  useCustomViewTabs,
} from 'src/pages/CustomViews/hooks/use-view-tabs';
import { useNavigateRoute, useRouteParams } from 'src/utils/routing';
import { SELECTED_VIEWS_BY_ENTITY } from './constants';

export const RootSelectedView = () => {
  const { entityName: selectedEntity } = useRouteParams(UrlParams.entityName);
  const { partnerPrefix } = useNavigateRoute();

  const entity = MAP_URL_ENTITY_NAME_TO_ENTITY[selectedEntity] ?? selectedEntity;

  const { tabs, loading } = useCustomViewTabs();

  const hasAccessToEntity = useMemo(() => {
    if (loading) {
      return true;
    }

    return tabs.some((tab) => tab.entity === entity);
  }, [tabs, loading, entity]);

  if (!hasAccessToEntity) {
    return <Navigate to={getFirstAccessibleTabPath(tabs, partnerPrefix)} replace />;
  }

  const Component = SELECTED_VIEWS_BY_ENTITY[entity];

  if (!Component) {
    return null;
  }

  return <Component />;
};
